import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { snapshot } from '@principle-theorem/shared';
import { ManagementToolContextService } from '../management-tool-context.service';
import { ManagementToolSidebarService } from '../management-tool-sidebar.service';
import { IToolListItem } from '../models/management-tool';

@Component({
  selector: 'pt-management-tool-panel',
  templateUrl: './management-tool-panel.component.html',
  styleUrls: ['./management-tool-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex flex-col w-full border-2 border-solid border-primary-500 h-full bg-white overflow-hidden',
  },
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatTooltipModule,
  ],
})
export class ManagementToolPanelComponent {
  private _contextService = inject(ManagementToolContextService);
  sidebar = inject(ManagementToolSidebarService);

  resourceGroups$ = this._contextService.resourceGroups$;
  @Output() closePanel = new EventEmitter<void>();

  async runTool(item: IToolListItem): Promise<void> {
    const disabled = await snapshot(item.disabled$);
    if (disabled) {
      return;
    }
    await item.tool.run({
      resource: item.matchingResource,
    });
  }
}
